export const inspectTable_1 = [
  {
    content: `안전보호구 착용`,
    isChecked: [],
  },
  {
    content: `장비(수공구, 용접기, 달기구 등) 사전점검`,
    isChecked: [],
  },
  {
    content: `작업장 정리정돈`,
    isChecked: [],
  },
  {
    content: `MSDS 게시 및 교육, 경고표지 부착`,
    isChecked: [],
  },
  {
    content: `근로자 외 출입 금지 조치`,
    isChecked: [],
  },
  {
    content: `ILS 조치 및 잠금표지부착`,
    isChecked: [],
    rowType: "customContent",
    customType: "1",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `안전시설물 (안전난간, 개구부 등) 상태점검/조치`,
    isChecked: [],
  },
];

export const inspectTable_2 = [
  {
    content: `가연성물질에 대한 방호조치(역화방지기 등)`,
    isChecked: [],
  },
  {
    content: `소화기구(소화기 등) 비치`,
    isChecked: [],
  },
  {
    content: `인화성 액체/가스등의 환기 조치`,
    isChecked: [],
  },
  {
    content: `불꽃, 불티 등 비산방지조치`,
    isChecked: [],
  },
  {
    content: `화재감시자 배치`,
    isChecked: [],
    rowType: "customContent",
    customType: "1",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `가스사용시 누출점검, 밸브차단, 표지부착`,
    isChecked: [],
  },
  {
    content: `작업위험성평가(JSA)  ※ PSM 대상인 경우 표시`,
    isChecked: [],
  },
];

export const inspectTable_3 = [
  {
    content: `작업발판 설치여부`,
    isChecked: [],
  },
  {
    content: `추락방호망 설치여부`,
    isChecked: [],
  },
  {
    content: `안전대 착용 (안전대 부착설비 설치여부)`,
    isChecked: [],
  },
  {
    content: `개구부등의 방호조치 (난간등 설치), 개구부표시`,
    isChecked: [],
  },
  {
    content: `지붕위 작업 위험방지 (안전난간,덮개설치, 발판설치)`,
    isChecked: [],
  },
  {
    content: `울타리 설치`,
    isChecked: [],
  },
  {
    content: `조명 유지 여부`,
    isChecked: [],
  },
];

export const inspectTable_4 = [
  {
    content: `투입장비 :`,
    isChecked: [],
    rowType: "customContent",
    customType: "1",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `작업계획서 작성/비치`,
    isChecked: [],
  },
  {
    content: `작업지휘자, 유도자(신호수) 배치`,
    isChecked: [],
  },
  {
    content: `작업장내 관계자외 출입통제 관리`,
    isChecked: [],
  },
  {
    content: `중량물 운반 및 적재시 안전조치 점검`,
    isChecked: [],
  },
  {
    content: `작업장소 지형 및 기상상태 사전점검`,
    isChecked: [],
  },
  {
    content: `작업 전 방호장치 작동유무 점검`,
    isChecked: [],
  },
];

export const inspectTable_5 = [
  {
    content: `안전교육/훈련 (특별교육 포함)`,
    isChecked: [],
  },
  {
    content: `작업주요사항(작업,작업자정보,가스농도,보호구등) 게시`,
    isChecked: [],
  },
  {
    content: `산소 및 유해가스농도 측정/확인`,
    isChecked: [],
  },
  {
    content: `작업장 환기`,
    isChecked: [],
  },
  {
    content: `공기호흡기 또는 송기마스크 지급착용`,
    isChecked: [],
  },
  {
    content: `밀폐공간 입장 및 퇴장 인원 점검`,
    isChecked: [],
  },
  {
    content: `감시인 지정 배치`,
    isChecked: [],
    rowType: "customContent",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `전화 및 무선기기(연락수단) 구비`,
    isChecked: [],
  },
  {
    content: `<span style="color: #4839EB">구조용 기구 비치 (구명선, 윈치 등)</span>`,
    isChecked: [],
  },
  {
    content: `<span style="color: #4839EB">저전압 방폭조명장비 확보</span>`,
    isChecked: [],
  },
  {
    content: `<span style="color: #4839EB">방폭형 공구 사용</span>`,
    isChecked: [],
  },
];

export const inspectTable_6 = [
  {
    content: `유자격자 작업여부`,
    isChecked: [],
  },
  {
    content: `전원차단, ILS 조치 및 표지부착`,
    isChecked: [],
    rowType: "customContent",
    customType: "1",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `잔류전하 방전, 단락접지, 검전기이용 통전여부 확인`,
    isChecked: [],
  },
  {
    content: `전원 재투입전 주변상태 점검(작업자,단락기구 등)`,
    isChecked: [],
  },
  {
    content: `절연보호구 사용`,
    isChecked: [],
  },
  {
    content: `접근한계거리 확인/ 이격거리 유지`,
    isChecked: [],
  },
  {
    content: `전원차단`,
    isChecked: [],
    rowType: "customContent",
    customType: "2",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `전원복구`,
    isChecked: [],
    rowType: "customContent",
    customType: "3",
    contentStyle: { "align-items": "center" },
  },
];
export const inspectTable_7 = [
  {
    content: `지반등 굴착시 위험방지 (기울기 기준 준수 등)`,
    isChecked: [],
  },
  {
    content: `주변부석, 균열유무, 함수,용수 및 동결상태 사전점검`,
    isChecked: [],
  },
  {
    content: `흙막이 지보공설치, 방호망설치, 근로자출입금지조치`,
    isChecked: [],
  },
  {
    content: `매설물(가스, 전기, 그밖의 공작물)등 사전확인 및 조치`,
    isChecked: [],
  },
  {
    content: `운행경로 및 토석 적재장소 출입방법 근로자 주지`,
    isChecked: [],
  },
  {
    content: `유도자 배치`,
    isChecked: [],
  },
  {
    content: `흙막이지보공 조립시 조립도에 따라 작업, 점검/보수`,
    isChecked: [],
  },
];
export const inspectTable_8 = [
  {
    content: `작업감시자 배치 :`,
    isChecked: [],
    rowType: "customContent",
    customType: "1",
    contentStyle: { "align-items": "center" },
  },
  {
    content: `방사성물질의 밀폐등(차폐, 경보시설등), 보호구착용`,
    isChecked: [],
  },
  {
    content: `방사선구역 지정 및 주의사항등 게시(출입금지조치 포함)`,
    isChecked: [],
  },
  {
    content: `방사성물질 취급 전용용구사용/표시`,
    isChecked: [],
  },
  {
    content: `작업에 필요한 보호구 착용 여부`,
    isChecked: [],
  },
  {
    content: `작업 유해성등에대한 근로자 안내`,
    isChecked: [],
  },
  {
    content: `<span style="color: #4839EB">방사선 방사위치 표기 확인 (도면 별첨)</span>`,
    isChecked: [],
  },
];
